import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { Button, Row, Col, Panel, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import API from "../base/API";
import { browserHistory } from "react-router";
import Auth from "../auth/Auth";
import { translate } from '../base/Translation';

export default class ErrorDBNew extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			save_error_db: "/error_db/save/new",
		});

		this.state = {
			error_db: {
				id: 0,
				name: translate("Nová databáza"),
			},
		};
	}

	onSave(evt) {
		this.api.request({
			route: "save_error_db",
			data: this.state.error_db,
			created: (response) => {
				browserHistory.push("/error_dbs");
			}
		});
	}

	onChange(evt) {
		// Get protocol from state
		let newErrorDB = this.state.error_db;

		// Update it's value
		newErrorDB[evt.target.name] = evt.target.value;

		// Update vehicle in state
		this.setState({ error_db: newErrorDB });
	}

	renderOptions(data) {
		let options = data.map(function (item) {
			return (
				<option value={item.id} key={item.id}>{typeof item.name !== "undefined" ? item.name : item.email}</option>
			)
		});

		return (options);
	}

	render() {

		return (
			<Page>
				<PageHeader title={this.state.error_db.name} />
				<PageBody>
					<Row>
						<Col lg={6}>
							<Panel header={translate("Základné")}>
								<FormGroup>
									<ControlLabel>{translate("Názov")}</ControlLabel>
									<FormControl defaultValue={this.state.error_db.name} name="name" onChange={this.onChange.bind(this)} />
								</FormGroup>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<FormGroup>
								<Button bsStyle="success" onClick={this.onSave.bind(this)}>{translate("Uložiť")}</Button>
							</FormGroup>
						</Col>
					</Row>
				</PageBody>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/error_db/ErrorDBNew.js